// import Tablesaw from 'tablesaw/dist/stackonly/tablesaw.stackonly';
import { debounce, forEach } from '../global/helpers';

const tables = document.querySelectorAll('table');

function handleTableResize() {
	forEach(tables, (i, table) => {
		const wrapper = table.parentElement.parentElement;
		if (table.offsetWidth > wrapper.offsetWidth) {
			wrapper.classList.add('overflow');
		} else {
			wrapper.classList.remove('overflow');
		}
	});
}

function initResponsiveTables() {
	forEach(tables, (i, table) => {
		const wrapper = document.createElement('div');
		wrapper.classList.add('responsive-table');

		const inner = document.createElement('div');
		inner.classList.add('responsive-table__inner');

		wrapper.appendChild(inner);
		table.parentNode.insertBefore(wrapper, table);
		inner.appendChild(table);
	});

	handleTableResize();
}

document.addEventListener('DOMContentLoaded', initResponsiveTables);
window.addEventListener('resize', debounce(handleTableResize, 50, false));
